export const version = '0.801.0'
export const chameleonWebVersion = '10.1.1'
export const chameleonCoreVersion = '7.12.1'
